import { render } from "./CardSlider.vue?vue&type=template&id=2a4745a1"
import script from "./CardSlider.vue?vue&type=script&lang=js"
export * from "./CardSlider.vue?vue&type=script&lang=js"

import "./CardSlider.vue?vue&type=style&index=0&id=2a4745a1&lang=sass"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__